// Port of api/fuel/app/classes/filter/search/users/sorts/query/collection.php
import { sorted, sortReverse, sortPriority } from 'offline/filter/core/search/unit'
export default {
	name: 'collection',
	post: false,
	require: function(config, filter) { return sorted('collection', filter) > 0 },
	run: function(config, filter, data, query) {
		query.order('u.user_count_collection', sortReverse('collection', filter), sortPriority('collection', filter))
	}
}
